import React, { type FC } from 'react';

export const PublishTemplate: FC = () => {
    const publishAImage = new URL('./publish-a.png', import.meta.url).toString();
    const publishBImage = new URL('./publish-b.png', import.meta.url).toString();

    return (
        <div className="text-white flex flex-col gap-4 pb-2">
            <p className="text-2xl">Publish Template</p>
            <p>
                When you click "Publish Template", the template will be added to your team's creative section, making it
                accessible to everyone on your team. This allows all members to use the same template in their own
                projects, helping maintain consistency and streamline the design process across the workspace.
            </p>
            <img src={publishAImage} alt="publish-a" />
            <p>
                After a template is published, you can easily share it by copying its link or sending it directly via
                email.
            </p>
            <img src={publishBImage} alt="publish-b" />
        </div>
    );
};
